import {all} from 'redux-saga/effects'
import { routinePromiseWatcherSaga } from 'redux-saga-routines';
import helpers from './helpers';
import authorization from './authorization';
import currentRide from './currentRide';
import forms from './forms';
import location from './location';
import firebase from './firebase';

export default function* rootSaga(dispatch, getState) {
  const effects = [
    ...helpers,
    ...forms,
    ...authorization,
    ...currentRide,
    ...location,
    ...firebase,
    routinePromiseWatcherSaga()
  ];


  yield all(effects.map(e => typeof e === "function" ? e({dispatch, getState}) : e));
}
